// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/productivity-ot-data/production-logs",
  Create: "/pyr/productivity-ot-data/production-logs",
  Sync: "/pyr/productivity-ot-data/production-logs/sync",
};
